import { useSocialListeningTopicsStore } from '@/stores/social-listening-topics';
import { useRoute } from 'vue-router';
import {
  FILTER_TYPE,
  SOCIAL_LISTENING_VISUAL_FILTER_TYPES,
  VISUAL_DATA_TYPES,
} from '@/app/socialListening/constants';
import { socialListeningFiltersEvent } from '@/app/socialListening/utils/mixpanel-events';

export function handleVisualFilterOverlayClick(include, media, tempUsage = true) {
  const topicsStore = useSocialListeningTopicsStore();
  const route = useRoute();
  const brandId = media.brandType?.split(':')[0] || null;
  const item = {
    sizes: media.urls?.imageSizes ?? media.urls?.videoSizes,
    mediaType: media.mediaType,
    source: media.source,
    filterType: brandId ? VISUAL_DATA_TYPES.LIBRARY : VISUAL_DATA_TYPES.TRENDS,
    id: `${brandId ? `${brandId}:` : ''}${media.source}:${media.sourceId}`,
    videoDuration: media.videoDuration,
  };
  topicsStore.updateVisualFilters(include, item, undefined, 0, tempUsage);
  topicsStore.tempVisualFiltersChanged = true;
  socialListeningFiltersEvent({
    filterUsed: FILTER_TYPE.VISUAL.value,
    filterValue: {
      value: `${include ? 'includes' : 'excludes'}:${media.sourceId}`,
      selection: SOCIAL_LISTENING_VISUAL_FILTER_TYPES.TOP_PERFORMING,
    },
    section: route?.meta?.section,
    eventFrom: route?.name,
  });
}
